
import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import QuickStats from '@/components/dashboard/QuickStats';
import SubscriptionStatus from '@/components/subscription/SubscriptionStatus';
import ActivityFeed from '@/components/dashboard/ActivityFeed';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const Index: React.FC = () => {
  const { user } = useAuth();

  return (
    <MainLayout>
      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold tracking-tight">Tableau de bord</h1>
          <Link to="/subscription-change/new">
            <Button className="gap-1">
              Gérer l'abonnement
              <ArrowUpRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
        
        <QuickStats />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <SubscriptionStatus />
          <ActivityFeed />
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle>Bienvenue dans votre espace</CardTitle>
            <CardDescription>
              Voici quelques étapes pour bien démarrer avec notre plateforme
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4 relative before:absolute before:left-3 before:top-0 before:h-full before:w-[1px] before:bg-muted">
              <div className="relative pl-8">
                <h3 className="font-medium">Complétez votre profil</h3>
                <p className="text-sm text-muted-foreground">Ajoutez vos informations pour personnaliser votre compte</p>
              </div>
              <div className="relative pl-8">
                <h3 className="font-medium">Choisissez votre plan</h3>
                <p className="text-sm text-muted-foreground">Sélectionnez le plan qui correspond à vos besoins</p>
              </div>
              <div className="relative pl-8">
                <h3 className="font-medium">Invitez votre équipe</h3>
                <p className="text-sm text-muted-foreground">Ajoutez des membres à votre équipe pour collaborer</p>
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button variant="outline" className="w-full">Voir tous les guides</Button>
          </CardFooter>
        </Card>
      </div>
    </MainLayout>
  );
};

export default Index;
